// Umami, self-hosted. Cookie-free, and never given personal data: events carry no payload
// that identifies anyone. Every path here must swallow failure: analytics never breaks the app.
const SCRIPT_URL = 'https://umami.zookee.one/script.js'
const PROD_DOMAIN = 'tomeofmanyfac.es'

/** The key Umami's own script honours: set, it sends nothing. */
export const UMAMI_OPT_OUT_KEY = 'umami.disabled'

declare global {
  interface Window {
    umami?: { track: (name: string, data?: Record<string, string | number | boolean>) => void }
  }
}

export function initAnalytics(websiteId: string | undefined): void {
  if (!websiteId || document.querySelector('script[data-website-id]')) return
  const script = document.createElement('script')
  script.defer = true
  script.src = SCRIPT_URL
  script.dataset.websiteId = websiteId
  script.dataset.domains = PROD_DOMAIN
  script.dataset.excludeSearch = 'true'
  script.dataset.excludeHash = 'true'
  script.dataset.doNotTrack = 'true'
  document.head.appendChild(script)
}

export function track(name: string, data?: Record<string, string | number | boolean>): void {
  try {
    window.umami?.track(name, data)
  } catch {
    // a blocked or broken script is none of the app's business
  }
}

export function isAnalyticsOptedOut(): boolean {
  try {
    return localStorage.getItem(UMAMI_OPT_OUT_KEY) !== null
  } catch {
    return false
  }
}

export function setAnalyticsOptOut(optedOut: boolean): void {
  try {
    if (optedOut) localStorage.setItem(UMAMI_OPT_OUT_KEY, '1')
    else localStorage.removeItem(UMAMI_OPT_OUT_KEY)
  } catch {
    // storage unavailable: nothing to persist, and the script cannot read it either
  }
}
